module.exports = __webpack_public_path__ + "static/media/Online Store 5.ea41d643.png";